import {ChangeDetectionStrategy, Component, effect, inject, signal} from '@angular/core';
import {AlertService} from './alert.service';

@Component({
  selector: 'green-x-alert',
  template: `
    @if (message()) {
      <div class="alert-container alert alert-danger alert-dismissible fade show" role="alert">
        {{ message() }}
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAlert()"></button>
      </div>
    }
  `,
  imports: [],
  styles: [`
    .alert-container {
      position: fixed;
      left: 50%;
      transform: translate(-50%, 50%);
      width: 50%;
      z-index: 1060;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  message = signal<string | null>(null);

  private alertService = inject(AlertService);

  constructor() {
    effect(() => {
      this.message.set(this.alertService.alertMessage());
    });
  }

  closeAlert() {
    this.message.set(null);
  }
}
